import { ChangeEvent, SetStateAction } from "react";
import { ServiceValidationWithId } from "./typings/ServiceValidationWithId.type";

export function handleChangeBookingLeadTime({
  val,
  rowId,
  validationErrors,
  setValidationErrors
}: {
  val: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>;
  rowId: number;
  validationErrors: ServiceValidationWithId;
  setValidationErrors: (value: SetStateAction<ServiceValidationWithId>) => void;
}) {
  if (val.currentTarget.value === "") {
    setValidationErrors({
      ...validationErrors,
      [rowId]: { bookingLeadTime: undefined }
    });
  }
}

export function handleChangeSetUpTime({
  val,
  rowId,
  validationErrors,
  setValidationErrors
}: {
  val: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>;
  rowId: number;
  validationErrors: ServiceValidationWithId;
  setValidationErrors: (value: SetStateAction<ServiceValidationWithId>) => void;
}) {
  if (val.currentTarget.value === "") {
    setValidationErrors({
      ...validationErrors,
      [rowId]: { setUpTime: undefined }
    });
  }
}
